import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import { getUserOptionsWithEmployeeProfile } from "features/Users/services/UserService";
import {
  EmployeeOption,
  EmployeeSingleValue,
} from "features/Employees/components/EmployeeSelectComponents";
import type { SelectOption } from "types/api.types";
import {
  WorkAssignmentSourceType,
  WorkAssignmentSourceTypeLabel,
  WORK_ASSIGNMENT_LIST_STATUSES,
  workAssignmentStatusMap,
  WorkAssignmentStatus,
} from "features/WorkAssignments/constants/work-assignment.constants";

const LIST_SOURCE_TYPES = Object.values(
  WorkAssignmentSourceType,
) as WorkAssignmentSourceType[];

export type WorkAssignmentListFiltersProps = {
  selectedStatus: WorkAssignmentStatus | "";
  onStatusChange: (status: WorkAssignmentStatus | "") => void;
  selectedSourceType: WorkAssignmentSourceType | "";
  onSourceTypeChange: (t: WorkAssignmentSourceType | "") => void;
  assigneeUserId: number | null;
  onAssigneeUserIdChange: (v: number | null) => void;
};

export default function WorkAssignmentListFilters({
  selectedStatus,
  onStatusChange,
  selectedSourceType,
  onSourceTypeChange,
  assigneeUserId,
  onAssigneeUserIdChange,
}: WorkAssignmentListFiltersProps) {
  return (
    <>
      <select
        className="form-select"
        style={{ width: "auto", minWidth: 130 }}
        value={selectedStatus}
        onChange={(e) =>
          onStatusChange(e.target.value as WorkAssignmentStatus | "")
        }
      >
        <option value="">All statuses</option>
        {WORK_ASSIGNMENT_LIST_STATUSES.map((st) => (
          <option key={st} value={st}>
            {workAssignmentStatusMap[st]?.label ?? st}
          </option>
        ))}
      </select>

      <select
        className="form-select"
        style={{ width: "auto", minWidth: 120 }}
        value={selectedSourceType}
        onChange={(e) =>
          onSourceTypeChange(e.target.value as WorkAssignmentSourceType | "")
        }
      >
        <option value="">All types</option>
        {LIST_SOURCE_TYPES.map((t) => (
          <option key={t} value={t}>
            {WorkAssignmentSourceTypeLabel[t]}
          </option>
        ))}
      </select>

      <div style={{ minWidth: 180 }}>
        <AsyncPaginatedSelect
          fetchOptions={getUserOptionsWithEmployeeProfile}
          placeholder="Any assignee…"
          components={{
            Option: EmployeeOption,
            SingleValue: EmployeeSingleValue,
          }}
          value={assigneeUserId}
          onChange={(opt) =>
            onAssigneeUserIdChange(
              opt && !Array.isArray(opt)
                ? Number((opt as SelectOption).value)
                : null,
            )
          }
        />
      </div>
    </>
  );
}
